import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { gameStateManager } from '../../App';
import SliderOption from '../Utils/SliderOption';
import '../../css/bugReportRow.css';

export default class BugReportRow extends React.Component
{
  state = {
    skipToTileIndex: 0,
    skipToFeatureResolveIndex: 0,
    playbackTurnSpeed: 2,
    resolveAILogic: true
  };

  onDebugPlayback = event =>
  {
    event.preventDefault();

    // Process the forms input data to get the room ID
    const formData = new FormData( event.target );
    const formDataObj = Object.fromEntries( formData.entries() );

    // console.log("onDebugPlayback - formDataObj : ", formDataObj);

    const {
      bugReportId
    } = formDataObj;

    const { skipToTileIndex, skipToFeatureResolveIndex, playbackTurnSpeed, resolveAILogic } = this.state;

    console.log( "skipToTileIndex : " + skipToTileIndex, "skipToFeatureResolveIndex : ", skipToFeatureResolveIndex, "playbackTurnSpeed", playbackTurnSpeed );

    // Create the playback URL with parameters
    const baseUrl = window.location.origin;
    const playbackUrl = `${baseUrl}/playback?bugReportId=${bugReportId}&skipToTile=${skipToTileIndex}&skipToFeature=${skipToFeatureResolveIndex}&speed=${playbackTurnSpeed}&resolveAILogic=${resolveAILogic ? 1 : 0}`;

    // Open the debug playback in a new tab
    window.open( playbackUrl, '_blank', 'noopener,noreferrer' );
  };

  onServerErrorReceived = errorData =>
  {
    console.log( "onServerErrorReceived - ", errorData );
  }

  render()
  {
    let data = this.props.bugReportData;

    return (
      <div className="bug-report-row">
        <Form onSubmit={ this.onDebugPlayback }>

          <div className="bug-report-header">
            <div className="bug-report-info room-id">
              <span className="label">Room:</span> { data.roomId }
            </div>

            <div className="bug-report-info players-count">
              <span className="label">Players:</span> { data.numPlayers }
            </div>

            <div className="bug-report-info moves-count">
              <span className="label">Moves:</span> { data.numTilePlacements }
            </div>

            <div className="bug-report-info date-reported">
              <span className="label">Reported:</span> { data.dateReported }
            </div>
          </div>

          <input
            type="hidden"
            value={ data.bugReportId }
            name="bugReportId"
          />

          <div className="bug-report-description">
            <label className="description-label">Bug Report Description:</label>
            <div className="user-context-list">
              { data.userContext && Array.isArray( data.userContext ) && data.userContext.length > 0 ?
                data.userContext.map( ( context, index ) => (
                  <div key={ index } className="user-context-item">
                    <div className="user-id">
                      <strong>User ID:</strong> { context.userID }
                    </div>
                    <textarea
                      className="provided-info"
                      value={ context.providedInfo || 'No context provided' }
                      readOnly
                      rows={ 3 }
                    />
                  </div>
                ) ) :
                <div className="no-context">No bug report descriptions provided</div>
              }
            </div>
          </div>

          <div className="bug-report-controls">
            <div className="control-group">
              <SliderOption
                title="Skip To Tile:"
                min={ 0 }
                max={ data.numTilePlacements }
                value={ 0 }
                onValueChange={ ( newValue ) => { this.setState( { 'skipToTileIndex': newValue } ); } }
              />
            </div>

            <div className="control-group">
              <SliderOption
                title="Skip To End Game Feature Resolve:"
                min={ 0 }
                max={ 50 }
                value={ 0 }
                onValueChange={ ( newValue ) => { this.setState( { 'skipToFeatureResolveIndex': newValue } ); } }
              />
            </div>

            <div className="control-group">
              <SliderOption
                title="Play Speed (Seconds):"
                min={ 0 }
                max={ 10 }
                value={ this.state.playbackTurnSpeed }
                onValueChange={ ( newValue ) => { this.setState( { 'playbackTurnSpeed': newValue } ); } }
              />
            </div>

            <div className="control-group">
              <Form.Check
                type="switch"
                id="resolveAILogic"
                label="Resolve AI Logic"
                checked={ this.state.resolveAILogic }
                onChange={ ( event ) => { this.setState( { 'resolveAILogic': event.target.checked } ); } }
              />
            </div>

            <button type="submit" className="debug-button">
              Debug Playback
            </button>
          </div>
        </Form>
      </div>
    );
  }
}
